import { darken, styled } from '@mui/material';

export const Ribbon = styled('div', { shouldForwardProp: prop => prop !== 'ribbonColor' })<{ ribbonColor?: string }>(
  ({ ribbonColor, theme }) => ({
    '& span': {
      backgroundColor: ribbonColor ?? theme.palette.primary.main,
      color: theme.palette.common.white,
      display: 'block',
      fontSize: '0.75rem',
      fontWeight: 'bold',
      padding: `${theme.spacing(0.5)} 0`,
      position: 'absolute',
      right: '-13px',
      textAlign: 'center',
      textTransform: 'uppercase',
      top: '25px',
      transform: 'rotate(-45deg)',
      width: '250px',
      zIndex: 2,
    },
    '&:after': {
      bottom: '56px',
      left: '-6px',
    },
    '&:before': {
      right: '56px',
      top: '-6px',
    },
    '&:before,&:after': {
      border: `5px solid ${darken(ribbonColor ?? theme.palette.primary.main, 0.4)}`,
      borderLeftColor: 'transparent',
      borderTopColor: 'transparent',
      content: '""',
      display: 'block',
      position: 'absolute',
      zIndex: 1,
    },
    height: '150px',
    left: `-${theme.spacing(0.5)}`,
    overflow: 'hidden',
    position: 'absolute',
    top: `-${theme.spacing(0.5)}`,
    width: '150px',
  }),
);
